import React, { useState, useEffect } from "react";
import "../../../assets/css/wishlist.css";
import { FaTrash } from "react-icons/fa";
import { useSelector } from "react-redux";
import { savewishlist } from "../../../features/HomePageSlice/homeDataSlice";
import { endpoint } from "../../../api/endpoint";
import { apiHandler } from "../../../api";
import {
  PRODUCT_DETAILS,
  REMOVE_PRODUCT_FROM_WISHLIST,
  GETWISHLIST_V2,
  WISHLIST_ID,
} from "../../../assets/graphql";
import { useDispatch } from "react-redux";
import { checkSessionValidity, getSampleCurrencyFormat } from "../../../utils/utils";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

const WishlistSectionCard = ({
  ids,
  uid,
  sku,
  wishlist_img,
  ProductName,
  final_price,
  Amount,
  Discount,
  stockStatus,
  wishlistConfigure,
  selectedOptions,
}) => {
  const { id } = useParams();
  const navigate = useNavigate();

  const loginUser = localStorage.getItem("loginURL");
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.login);
  const { wishlist, customerresult } = useSelector((state) => state.home);

  const [filter, setFilter] = useState([]);
  const [wishlistIdZero, setWishlistIdZero] = useState("");
  // console.log(wishlistConfigure);
  const filterVariant = async () => {
    let selVariants = null;
    // setLoader(true);
    const result = await apiHandler({
      url: endpoint.GRAPHQL_URL,
      method: "POST",
      authToken: token,
      data: {
        base_url: endpoint.API_BASE_URL,
        variables: { sku: decodeURIComponent(sku) },
        query: PRODUCT_DETAILS,
      },
    });
    checkSessionValidity(result.data, dispatch);
    // setLoader(false);
    if (!result.data.error_code) {
      const productDetails = result.data.products.items;

      productDetails &&
        productDetails.map((product, index) => {
          const { variants } = product;

          // filter product
          selVariants = variants.filter((v) => {
            return v.product.uid === uid;
          });
        });
    }
    return selVariants;
  };
  const getWishlistId = async () => {
    if (token) {
      const result = await apiHandler({
        url: endpoint.GRAPHQL_URL,
        method: "POST",
        authToken: token,
        data: {
          base_url: endpoint.API_BASE_URL,
          variables: {},
          query: WISHLIST_ID,
        },
      });
      checkSessionValidity(result.data, dispatch);
      // console.log("wishlistid:-", result);
      setWishlistIdZero(result.data.customer.wishlist_v2);
    } else {
      if(loginUser) {
        navigate(`/${loginUser}`)
      } else {
          navigate("/default");
      }
      // navigate("/default");
    }
  };
  useEffect(() => {
    getWishlistId();
  }, []);

  const getWishListData = async () => {
    const wishlistresult = await apiHandler({
      url: endpoint.GRAPHQL_URL,
      method: "POST",
      authToken: token,
      data: {
        base_url: endpoint.API_BASE_URL,
        variables: {},
        query: GETWISHLIST_V2,
      },
    });
    // console.log("wishlistresult", wishlistresult);
    checkSessionValidity(wishlistresult.data, dispatch);
    if (!wishlistresult.data.error_code) {
      dispatch(savewishlist(wishlistresult.data.customer.wishlist_v2));
    }
  };

  const RemoveWishlist = async (ids, noToast) => {
    if (token) {
      const result = await apiHandler({
        url: endpoint.GRAPHQL_URL,
        method: "POST",
        authToken: token,
        data: {
          base_url: endpoint.API_BASE_URL,
          variables: {
            wishlistId: wishlistIdZero.id,
            wishlistItemsIds: [ids],
          },
          query: REMOVE_PRODUCT_FROM_WISHLIST,
        },
      });
      checkSessionValidity(result.data, dispatch);

      if (!result.data.status) {
        if (!noToast) toast.success("Deleted Successfully");
        getWishListData();
      }
    } else {
      if(loginUser) {
        navigate(`/${loginUser}`)
      } else {
          navigate("/default");
      }
      // navigate("/default");
    }
  };

  return (
    <>
      <div className="product_single_box wishlist_page">
        <div className="share_options" onClick={() => RemoveWishlist(ids)}>
          <span className="delete">
            <i>
              <FaTrash />
            </i>
          </span>
        </div>
        <div className="wishlistaddtocart">
          <div className="product_img">
            <a href={"/#/product-detail/" + sku}>
              <img src={wishlist_img} alt="" />
            </a>
          </div>
          <div className="other_details">
            <div className="product_name">
              <a href={"/#/product-detail/" + sku}>{ProductName}</a>
            </div>
            <div className="product_price_row">
              <div className="final_price"> Price: {final_price}</div>
            </div>
            {wishlistConfigure.configurable_options &&
              wishlistConfigure.configurable_options.map((opt, i) => (
                <small key={i} className="d-block text-muted">
                  {opt.option_label}: {opt.value_label}{" "}
                </small>
              ))}
          </div>
        </div>
      </div>
    </>
  );
};
export default WishlistSectionCard;
